import React, { useState } from "react"
import PropTypes from "prop-types"
import { Paper } from "@material-ui/core"
import Button from "@mui/material/Button"
import { HelveticaBold } from "common/typographies"
import i18n from "i18n"

import ModalNumerationSettings from "./ModalNumerationSettings"

const NumerationSection = ({
  prefix1,
  prefix2,
  isDynamicNumberation,
  nextNumber,
}) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Paper elevation={0} style={{ padding: "16px", height: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: 1 }}>
            <HelveticaBold
              style={{ fontSize: "18px", color: "#414141", marginBottom: 8 }}
            >
              {i18n.t("numerationSettings.numeration")}
            </HelveticaBold>
            <div style={{ color: "#6d6d6d", fontSize: "14px", marginTop: 4 }}>
              {i18n.t("numerationSettings.setNumerationInfo")}
            </div>
          </div>
          <Button
            variant="contained"
            color="branded"
            style={{ marginLeft: 24, minWidth: 120 }}
            onClick={() => setOpen(true)}
          >
            {i18n.t("numerationSettings.configure")}
          </Button>
        </div>
      </Paper>
      <ModalNumerationSettings
        open={open}
        onClose={() => setOpen(false)}
        prefix1={prefix1}
        prefix2={prefix2}
        isDynamicNumberation={isDynamicNumberation}
        nextNumber={nextNumber}
      />
    </>
  )
}

export default NumerationSection

NumerationSection.propTypes = {
  prefix1: PropTypes.string,
  prefix2: PropTypes.string,
  isDynamicNumberation: PropTypes.bool,
  nextNumber: PropTypes.number,
}
